/**
 * 给标题编号，尽量对齐 iwiki 和 tapd 的行为
 */
export function numberHeadingInfos(infos, levels) {
    const context = levels.map(() => 0);
    let lastLevel = null;
    return infos.map((info) => {
        const { node } = info;
        const level = node.attrs.level;
        const index = levels.indexOf(level);
        // 传入了不在目标 levels 的节点，实际的使用上看不会有这种
        // 情况，但还是防御一下，无视掉这个节点
        if (index === -1) {
            return { ...info, numbering: '' };
        }
        if (level === lastLevel) {
            context[index]++;
        }
        else if (!lastLevel || level > lastLevel) {
            const lastIndex = lastLevel ? levels.indexOf(lastLevel) : 0;
            // index 比 lastIndex 大，注意考虑跳跃的情况
            for (let i = lastIndex; i <= index; i++) {
                if (i === index) {
                    context[i]++;
                }
                else if (context[i] === 0) {
                    context[i] = 1;
                }
            }
        }
        else {
            // 新起了一个更大的标题
            context[index]++;
            for (let i = index + 1; i < context.length; i++) {
                context[i] = 0;
            }
        }
        const numbering = `${context.slice(0, index + 1).join('.')}. `;
        lastLevel = level;
        return {
            ...info,
            numbering,
        };
    });
}
//# sourceMappingURL=helper.js.map